<app-paging-search-bar [parentApi]="getParentMethod()" [centered]="false"></app-paging-search-bar>

<table *ngIf="!loading && itemsToShow.length > 0" class="cp-std-table cp-auto-width">
	<thead>
		<tr app-column-headings [parentApi]="getParentMethod()" [columnDefs]="columnDefs" [fieldsToShow]="fieldsToShow"
			[displayOptions]="displayOptions">
		</tr>
	</thead>

	<tbody *ngIf="itemsToShow && !loading">
		<tr *ngFor="let item of itemsToShow">
			<td class="text-nowrap" [attr.data-order]="tt.formatDateTimeUTC(item.added_on)">
				{{ item.added_on | date: ac.tableDateTimeFmt }}
			</td>
			<td *ngIf="showObject" class="text-nowrap">{{ item.object_type }}</td>
			<td *ngIf="showObject" class="text-nowrap">
				<a *ngIf="item.object_type === 'zenmaster'" [routerLink]="['/' + ac.urls.zencustomers, item.object_id]">
					{{ item.object_name }}</a>
				<a *ngIf="item.object_type === 'activation'" [routerLink]="['/' + ac.urls.licensing, 'activation', item.object_id]">
					{{ item.object_name }}</a>
			</td>
			<td class="text-nowrap">{{ item.marketplace }}</td>
			<td class="text-nowrap">
				<span [ngbTooltip]="item.customer_id">
					{{ tt.chopString(item.customer_id, 15) }}
				</span>
			</td>
			<td class="text-nowrap">
				<span [ngbTooltip]="item['__product']">
					{{ tt.chopString(item['__product'], 15) }}
				</span>
			</td>
			<td class="text-nowrap">
				<span [ngbTooltip]="item.dimension_api_name">
					{{ tt.chopString(item.dimension_api_name, 15) }}
				</span>
			</td>
			<td class="text-nowrap" [attr.data-order]="tt.formatDateTimeUTC(item.report_start)" [title]="'From ' + tt.formatDateTimeUTC(item.report_start)
			+ ' to ' + tt.formatDateTimeUTC(item.report_end) + ' UTC'">
				{{ tt.formatDateNiceUTC(item.report_start) }}
			</td>
			<td class="text-end">{{ item.reported | number : '1.0-0' }}</td>
			<td>{{ item.receipt }}</td>
		</tr>
	</tbody>
</table>
<app-paging-bar [parentApi]="getParentMethod()" [pageNum]="displayOptions.pageNum" [pagingOptions]="pagingOptions"
	[centered]="false"></app-paging-bar>